import { Alert, Stack, Typography } from '@mui/material'
import MDButton from '../MDButton'
import StepHeader from './StepHeader'

export const SUMMARY_COMPANY_HEADER = 'החברה'

export const SUMMARY_CHANGE_LABEL = 'שינוי'

export const MISSING_COMPANY_LINK = 'יש לבחור חברה'

export const MISSING_COMPANY_MESSAGE = 'לא נבחרה חברה'

export const MISSING_RECIPIENTS_LINK = 'יש לבחור נמענים'

export const MISSING_SENDER_LINK = 'יש לבחור שם שולח'

export const MISSING_RECIPIENTS_MESSAGE = 'לא נבחרו נמענים'

export const MISSING_SENDER_MESSAGE = 'לא נבחר שם שולח'

export const SUMMARY_RECIPIENTS_HEADER = 'ההודעה תישלח אל'

export const SUMMARY_SENDER_HEADER = 'השם שיופיע בשדה "מאת"'

export const SUMMARY_CONTACTS_HEADER = 'פרטי הקשר שיופיעו בהודעה'

export const NO_CONTACTS_SUMMARY_MESSAGE = 'לא נבחרו פרטי קשר. מומלץ להוסיף לפחות אחד.'

export const NO_CONTACTS_LINK = 'לבחירת פרטי קשר'

const CONTENT_GROW = {
    flex: 1,
    minWidth: 0,
}

function MissingChoice({ testId, message, label, onFollow }) {
    return (
        <Alert
            severity="warning"
            data-testid={testId}
            action={
                <MDButton
                    variant="outlined"
                    color="warning"
                    data-testid={`${testId}-link`}
                    onClick={onFollow}
                >
                    {label}
                </MDButton>
            }
        >
            {message}
        </Alert>
    )
}

function SummarySection({ header, missing, changeTestId, onChange, children }) {
    return (
        <Stack
            direction="row"
            spacing={2}
            alignItems="flex-start"
            justifyContent="space-between"
        >
            <Stack spacing={0.5} sx={CONTENT_GROW}>
                <StepHeader>{header}</StepHeader>
                {children}
            </Stack>

            {!missing && (
                <MDButton
                    variant="outlined"
                    color="info"
                    data-testid={changeTestId}
                    onClick={onChange}
                >
                    {SUMMARY_CHANGE_LABEL}
                </MDButton>
            )}
        </Stack>
    )
}

export default function SendConfirmationStep({
    companyName,
    recipients,
    senderName,
    contacts,
    onGoToContacts,
    onGoToCompany,
    onGoToRecipients,
    onGoToSender,
    onFollowMissingRecipients,
}) {
    const companyMissing = companyName == null
    const recipientsMissing = recipients.length === 0
    const senderMissing = senderName == null
    const contactsEmpty = contacts.length === 0

    return (
        <Stack spacing={2} data-testid="send-confirmation">
            <SummarySection
                header={SUMMARY_COMPANY_HEADER}
                missing={companyMissing}
                changeTestId="summary-change-company"
                onChange={onGoToCompany}
            >
                {companyMissing
                    ? (
                        <MissingChoice
                            testId="summary-missing-company"
                            message={MISSING_COMPANY_MESSAGE}
                            label={MISSING_COMPANY_LINK}
                            onFollow={onGoToCompany}
                        />
                    )
                    : <Typography variant="body2">{companyName}</Typography>}
            </SummarySection>

            <SummarySection
                header={SUMMARY_RECIPIENTS_HEADER}
                missing={recipientsMissing}
                changeTestId="summary-change-recipients"
                onChange={onGoToRecipients}
            >
                {recipientsMissing
                    ? (
                        <MissingChoice
                            testId="summary-missing-recipients"
                            message={MISSING_RECIPIENTS_MESSAGE}
                            label={MISSING_RECIPIENTS_LINK}
                            onFollow={onFollowMissingRecipients}
                        />
                    )
                    : recipients.map((recipient) => (
                        <Typography key={recipient.id} variant="body2" data-testid={`summary-recipient-${recipient.id}`}>{recipient.value}</Typography>
                    ))}
            </SummarySection>

            <SummarySection
                header={SUMMARY_SENDER_HEADER}
                missing={senderMissing}
                changeTestId="summary-change-sender"
                onChange={onGoToSender}
            >
                {senderMissing
                    ? (
                        <MissingChoice
                            testId="summary-missing-sender"
                            message={MISSING_SENDER_MESSAGE}
                            label={MISSING_SENDER_LINK}
                            onFollow={onGoToSender}
                        />
                    )
                    : <Typography variant="body2" data-testid="summary-sender">{senderName}</Typography>}
            </SummarySection>

            <SummarySection
                header={SUMMARY_CONTACTS_HEADER}
                missing={contactsEmpty}
                changeTestId="summary-change-contacts"
                onChange={onGoToContacts}
            >
                {contactsEmpty
                    ? (
                        <Alert
                            severity="info"
                            data-testid="summary-no-contacts"
                            action={
                                <MDButton
                                    variant="outlined"
                                    color="info"
                                    data-testid="summary-no-contacts-link"
                                    onClick={onGoToContacts}
                                >
                                    {NO_CONTACTS_LINK}
                                </MDButton>
                            }
                        >
                            {NO_CONTACTS_SUMMARY_MESSAGE}
                        </Alert>
                    )
                    : contacts.map((contact) => (
                        <Typography key={contact.id} variant="body2" data-testid={`summary-contact-${contact.id}`}>{contact.value}</Typography>
                    ))}
            </SummarySection>
        </Stack>
    )
}
